
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcStatusIndicator as ObcStatusIndicatorElement} from '@oicl/openbridge-webcomponents/dist/components/status-indicator/status-indicator.js';
 
 
 

 
 export const ObcStatusIndicator = createComponent({
   react: React,
   tagName: 'obc-status-indicator',
   elementClass: ObcStatusIndicatorElement,
   events: {
     
   }
  });
 
 